import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { api } from "../api";

export function useCalendarData(userId: string, month: number, year: number) {
  const date = moment(`${month}-${year}`, "MM-YYYY").format();
  const startDate = moment(date).startOf("month").format("YYYY-MM-DD");
  const endDate = moment(date).endOf("month").format("YYYY-MM-DD");

  return useQuery({
    queryKey: ["calendarData", userId, startDate, endDate],
    queryFn: () => api.getCalendarData(userId, startDate, endDate),
    enabled: !!userId && !!month && !!year,
  });
}
